/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:relative;display:block;overflow:hidden;-webkit-overflow-scrolling:touch}.content[_ngcontent-%COMP%]{position:absolute;top:0;width:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/virtual-scroll/virtual-scroll.component.scss.shim.ngstyle.js.pre-build-optimizer.js